import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from "react-router-dom";
import PmsUrlConfig from '../../urlConfig';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';
import ErrorBoundary from '../ErrorBoundary';
import AddUserForm from './AddUserComponent';
import { getPractice, formatPhoneNumber } from '../common';
import { EditUserIcon } from './EditUserIcon.tsx';
import EditUserForm from './EditUserComponent';

export default function ViewUsers() {
    const dispatch = useDispatch();
    const practiceDetails = useSelector(state => state.practiceDetails);
    const loginDetails = useSelector(state => state.loginDetails);
    const [showAddUser, setShowAddUser] = useState(false);
    const [showEditUser, setShowEditUser] = useState(false);
    const [showHowItWorks, setShowHowItWorks] = useState(false);
    const [showHelpModal, setShowHelpModal] = useState(false);
    const [, setSelUserId] = useState('');
    if (!practiceDetails || practiceDetails.practice == null)
        <Navigate replace to={`${PmsUrlConfig.LOGIN_URL}`} />

    const practice = practiceDetails.practice;
    const practiceUsers = practice ? practice.user : null;

    if (!practiceUsers || practiceUsers.length === 0) {
        return (
            <div className="w-full p-6 text-center text-gray-500">
                <p>No Users Found</p>
            </div>
        )
    }
    var token = "";
    if (loginDetails) {
        token = loginDetails.jwtToken;
    }
    const handleAddUserShow = () => {

        dispatch({
            type: 'clearMsg'
        });
        setShowAddUser(true);
    }
    const handleAddUserClose = () => {
        setShowAddUser(false);
        dispatch({
            type: 'clearMsg'
        });
        getPractice(practice._id, dispatch, token);

    }
    const handleEditUserShow = () => {
        if (practiceDetails && practiceDetails.selectedUser == null) {
            return
        }
        dispatch({
            type: 'clearMsg'
        });
        setShowEditUser(true);
    }
    const handleEditUserClose = () => {
        setShowEditUser(false);
        dispatch({
            type: 'clearMsg'
        });
        getPractice(practice._id, dispatch, token);

    }
    const selectedUser = practice.selectedUser;

    if (selectedUser != null) {
        setSelUserId(selectedUser._id)
    }
    const handleSelectedUser = (selectedUserId) => {
        setSelUserId(selectedUserId);
        var selUserArray = practice.user.filter(pUser => (pUser._id === selectedUserId));
        if (selUserArray.length > 0) {

            dispatch({
                type: 'selectUser',
                payload: selUserArray[0]
            });
        }
        handleEditUserShow();
    }
    return (
        <div className="w-full">
            {/* Header Section */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2.5 sm:gap-4 mb-6 sm:min-h-[72px] lg:h-[91px]">
                <h1 className="text-xl font-bold text-gray-900">User Management</h1>
                <div className="flex gap-3">
                    <button
                        onClick={() => setShowHowItWorks(true)}
                        className="px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
                    >
                        How It Works
                    </button>
                    <button
                        onClick={handleAddUserShow}
                        className="px-6 py-2.5 bg-[#0B6D76] hover:bg-[#0A5A62] text-white font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2"
                    >
                        + Add New
                    </button>
                    <button
                        onClick={() => setShowHelpModal(true)}
                        className="px-6 py-2.5 inline-flex items-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Help
                    </button>
                </div>
            </div>

            {/* Desktop Table View */}
            <div className='hidden lg:block'>
                <div className='bg-white rounded-xl shadow-lg overflow-hidden'>
                    <div className='overflow-x-auto'>
                        <table className='w-full'>
                            <thead>
                                <tr className='border-b border-gray-200 bg-gray-50'>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Name</th>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Username</th>
                                    <th className='px-6 py-4 text-left text-sm font-semibold text-gray-600'>Phone Number</th>
                                    <th className='px-6 py-4 text-center text-sm font-semibold text-gray-600'>Status</th>
                                    <th className='px-6 py-4 text-center text-sm font-semibold text-gray-600'>Action</th>
                                </tr>
                            </thead>
                            <tbody className='divide-y divide-gray-200'>
                                {practiceUsers.map((pUser, index) => (
                                    pUser.firstname !== '' && pUser.lastname !== '' && (
                                        <tr key={index} className='hover:bg-gray-50 transition-colors'>
                                            <td className='px-6 py-4'>
                                                <div>
                                                    <p className='text-sm font-semibold text-gray-900'>{pUser.firstname + ' ' + pUser.lastname}</p>
                                                    <p className='text-xs text-gray-500 mt-1'>{pUser.user_type}</p>
                                                </div>
                                            </td>
                                            <td className='px-6 py-4 text-sm text-gray-700'>{pUser.username}</td>
                                            <td className='px-6 py-4 text-sm text-gray-700'>{formatPhoneNumber(pUser.phoneNum)}</td>
                                            <td className='px-6 py-4'>
                                                <div className={`inline-flex items-center justify-center px-4 py-2 rounded-lg text-sm font-medium min-w-[154px] ${
                                                    pUser.active_user 
                                                        ? 'bg-green-100 text-green-700' 
                                                        : 'bg-gray-100 text-gray-600'
                                                }`}>
                                                    {pUser.active_user ? 'Active' : 'Inactive'}
                                                </div>
                                            </td>
                                            <td className='px-6 py-4 text-center'>
                                                <button
                                                    onClick={() => handleSelectedUser(pUser._id)}
                                                    className='inline-flex items-center justify-center w-10 h-10 rounded-lg hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2'
                                                >
                                                    <EditUserIcon className='w-8 h-8 text-gray-600 transform -rotate-90' />
                                                </button>
                                            </td>
                                        </tr>
                                    )
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Mobile Card View */}
            <div className='lg:hidden space-y-4'>
                {practiceUsers.map((pUser, index) => (
                    pUser.firstname !== '' && pUser.lastname !== '' && (
                        <div key={index} className='bg-white rounded-xl shadow-lg p-4 hover:shadow-xl transition-shadow'>
                            <div className='flex items-start justify-between mb-3'>
                                <div className='flex-1'>
                                    <h3 className='text-base font-semibold text-gray-900'>
                                        {pUser.firstname + ' ' + pUser.lastname}
                                    </h3>
                                    <p className='text-sm text-gray-500 mt-1'>{pUser.user_type}</p>
                                </div>
                                <button
                                    onClick={() => handleSelectedUser(pUser._id)}
                                    className='ml-3 inline-flex items-center justify-center w-8 h-8 rounded-lg hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2'
                                >
                                    <EditUserIcon className='w-4 h-4 text-gray-600 transform -rotate-90' />
                                </button>
                            </div>
                            
                            <div className='space-y-2'>
                                <div className='flex items-center text-sm'>
                                    <span className='text-gray-500 font-medium w-24'>Username:</span>
                                    <span className='text-gray-700'>{pUser.username}</span>
                                </div>
                                <div className='flex items-center text-sm'>
                                    <span className='text-gray-500 font-medium w-24'>Phone:</span>
                                    <span className='text-gray-700'>{formatPhoneNumber(pUser.phoneNum)}</span>
                                </div>
                                <div className='flex items-center'>
                                    <span className='text-gray-500 font-medium text-sm w-24'>Status:</span>
                                    <div className={`inline-flex items-center justify-center px-3 py-1 rounded-md text-xs font-medium ${
                                        pUser.active_user 
                                            ? 'bg-green-100 text-green-700' 
                                            : 'bg-gray-100 text-gray-600'
                                    }`}>
                                        {pUser.active_user ? 'Active' : 'Inactive'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                ))}
            </div>
                    {/* Modals */}
                    <Modal show={showAddUser} onHide={handleAddUserClose} size='xl' centered backdrop="static">
                        <Modal.Header closeButton className="border-b border-gray-200">
                            <Modal.Title><h2 className="text-xl font-semibold text-gray-900">Add New User</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-6">
                            <ErrorBoundary>
                                <AddUserForm onSuccess={handleAddUserClose} />
                            </ErrorBoundary>
                        </Modal.Body>
                        
                    </Modal>
                    
                    <Modal show={showEditUser} onHide={handleEditUserClose} size='xl' centered backdrop="static">
                        <Modal.Header closeButton className="border-b border-gray-200">
                            <Modal.Title><h2 className="text-xl font-semibold text-gray-900">Update User Details</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-6">
                            <ErrorBoundary>
                                <EditUserForm onClose={handleEditUserClose} />
                            </ErrorBoundary>
                        </Modal.Body>
                    </Modal>

                    {/* How It Works Modal */}
                    <Modal show={showHowItWorks} onHide={() => setShowHowItWorks(false)} size='lg' centered>
                        <Modal.Header closeButton className="border-b border-gray-200">
                            <Modal.Title><h2 className="text-2xl font-bold text-gray-900">How It Works</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-6">
                            <div className="space-y-4 text-gray-700">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Connecting Patients with Your Practice</h3>
                                    <p className="leading-relaxed">
                                        The app works by connecting your practice with patients that are looking for the services provided by your practice. The patient will input the type of service they need and if your practice provides this service then you will receive a message in the appointment portion of the app. You can communicate with the patient in real time via the messaging through the app. It is fast and convenient. It will save a lot of time for the staff since they don't have to stay on the phone to make the appointments. Furthermore, one staff member can chat with multiple patients thus significantly reducing the need for staff time in creating appointments.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Administrative Tools</h3>
                                    <p className="leading-relaxed">
                                        Our administrative tools will help you to monitor many efficiency and productivity metrics such as the staff response time, conversion rate of request to appointments and more.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Setting Up Your Practice</h3>
                                    <p className="leading-relaxed">
                                        Setting up your practice is very easy. Set up the users and set up your services locations. You will need your admin credentials to do this.
                                    </p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-t border-gray-200">
                            <button
                                onClick={() => setShowHowItWorks(false)}
                                className="px-6 py-2.5 bg-[#0B6D76] hover:bg-[#0A5A62] text-white font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2"
                            >
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>

                    {/* Help Modal - How to Set Up Users */}
                    <Modal show={showHelpModal} onHide={() => setShowHelpModal(false)} size='lg' centered>
                        <Modal.Header closeButton className="border-b border-gray-200">
                            <Modal.Title><h2 className="text-2xl font-bold text-gray-900">How to Set Up Users</h2></Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="p-6">
                            <div className="space-y-4 text-gray-700">
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Login with Admin Credentials</h3>
                                    <p className="leading-relaxed">
                                        Login with your admin credentials to access user management features.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Select User Type</h3>
                                    <p className="leading-relaxed">
                                        You will need to select if the user will be admin user or a non-admin user. Non admin users will have the ability to view and send messages with patients. Admin users can add and delete users, practice locations, services provided, and modify account information.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Enter User Details</h3>
                                    <p className="leading-relaxed">
                                        Next enter the user's name. The app will create a login name for the user. You will create the password. If the user forgets the password, the admin can reset the password.
                                    </p>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer className="border-t border-gray-200">
                            <button
                                onClick={() => setShowHelpModal(false)}
                                className="px-6 py-2.5 bg-[#0B6D76] hover:bg-[#0A5A62] text-white font-semibold text-sm rounded-lg shadow-sm transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#0B6D76] focus:ring-offset-2"
                            >
                                Close
                            </button>
                        </Modal.Footer>
                    </Modal>
        </div>
    );
}